import { render } from "./Travels.vue?vue&type=template&id=7b213c12"
import script from "./Travels.vue?vue&type=script&lang=js"
export * from "./Travels.vue?vue&type=script&lang=js"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__